import script from "./BooleanButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./BooleanButtons.vue?vue&type=script&setup=true&lang=js"

import "./BooleanButtons.vue?vue&type=style&index=0&id=13696753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13696753"]])

export default __exports__